// To test in the future >
import 'regenerator-runtime/runtime';

declare var module: any;

// main entry file for sass
import "./scss/main.scss"

// main entry file for typescript
import "./scripts/main"

if (module.hot) {
  module.hot.accept()
}